import React, { type ComponentType } from 'react';
import styled, { css, type Runtime, type StyledInstance, type SupportedHTMLElements } from 'styled-components';

type BaseObject = {};
interface ExoticComponentWithDisplayName<P extends BaseObject = {}> extends React.ExoticComponent<P> {
  defaultProps?: Partial<P> | undefined;
  displayName?: string | undefined;
}
type AnyComponent<P extends BaseObject = any> = ExoticComponentWithDisplayName<P> | ComponentType<P>;
type KnownTarget = SupportedHTMLElements | AnyComponent;
type WebTarget = string | KnownTarget;
type NativeTarget = AnyComponent;
type StyledTarget<R extends Runtime> = R extends 'web' ? WebTarget : NativeTarget;

export const picoScope = <IP extends object, OS extends object>(
  base: StyledInstance<'web', StyledTarget<'web'>, IP, OS>,
  classNames: string[]
) => {
  const scoped = base.attrs({
    // @ts-ignore
    className: classNames.join(' '),
  });

  return (strings: TemplateStringsArray, ...expr: any[]) => scoped`
      &.${classNames.join('.')} {
        ${css(strings, ...expr)}
      }
    `;
};

const typedButtonBase = picoScope(styled.button, ['typed-button', 'outline', 'contract']);

export const DangerButton = typedButtonBase`
  --pico-primary-background: #ff0000;
  --pico-primary-hover-background: #e60000;
  --pico-primary-focus: #ff0000;
  --pico-color: #ff4d4d;
  --pico-border-color: #ff4d4d;
`;
